declare namespace $ {

	type $mol_view__style_bog_blitz_lobby_game_timer_1 = $mol_type_enforce<
		({ 
			'width': ReturnType< $bog_blitz_lobby_game_timer['bar_width'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	export class $bog_blitz_lobby_game_timer extends $mol_view {
		bar_width( ): string
		Bar( ): $mol_view
		duration( ): number
		round_start( ): number
		paused_at( ): number
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=timer.view.tree.d.ts.map